export const freCreditReportLink = 'https://freecreditreport.com';
